/**
 * 文の台帳（misc）。まとめは ../ui-texts.ts。
 * 管理UIへ写すので、../ui-texts.ts の型の他は何も import しない
 */
import type { UiTextDef } from "../ui-texts";

export const MISC_TEXTS = {
  // 場所と背景を選ぶ（タブの名前は src/lib の表なのでここに無い）
  "backgrounds.title": { text: "場所と背景を選ぶ", label: "いちばん上の見出し" },
  "backgrounds.homeHelp": { text: "地図で道を開いた場所へ移れます。場所ごとに、落ちる素材や出会える精霊が変わります。 「？？？」の場所は、地図で素材を払って道を開くと来られます。他の画面の背景は、素材や精霊に影響しません", label: "ホームのタブの説明", note: "ホームのタブだけ。前に館のアイコンが付く" },
  "backgrounds.openMap": { text: "地図を開く", label: "ホームのタブの説明の下のボタン", note: "ホームのタブだけ" },
  "backgrounds.emptyHome": { text: "行ける場所がまだありません", label: "空のとき（ホームのタブ）" },
  "backgrounds.emptyPage": { text: "このページの背景はまだありません", label: "空のとき（ホーム以外のタブ）" },
  "backgrounds.none.label": { text: "背景なし", label: "「背景なし」の本の題簽", note: "背景を選んでいるときだけ（ホームのタブには出ない）" },
  "backgrounds.none.removing": { text: "解除中...", label: "「背景なし」の本のボタン（外している間）" },
  "backgrounds.none.remove": { text: "背景を外す", label: "「背景なし」の本のボタン" },
  "backgrounds.locked.name": { text: "？？？", label: "まだ道の無い場所の名前", note: "絵の上の大きな字と、題簽の両方" },
  "backgrounds.locked.meta": { text: "{場所}・地図で道を開くと来られます", label: "まだ道の無い場所の説明", vars: "{場所}" },
  "backgrounds.locked.openMap": { text: "地図で道を開く", label: "まだ道の無い場所のボタン" },
  "backgrounds.open.current": { text: "いまいる場所", label: "開いた本の右の頁の見出し（ホームのタブ）" },
  "backgrounds.open.selected": { text: "使用中の背景", label: "開いた本の右の頁の見出し（ホーム以外のタブ）" },
  "backgrounds.drop.none": { text: "属性なし", label: "素材の出やすい属性（属性の無い場所）", note: "ホームのタブだけ" },
  "backgrounds.drop.genre": { text: "{属性}属性", label: "素材の出やすい属性の一つ分", note: "ホームのタブだけ。いくつかあると / でつなぐ", vars: "{属性}" },
  "backgrounds.drop.up": { text: "素材ドロップUP属性・{属性}", label: "素材の出やすい属性", note: "ホームのタブだけ", vars: "{属性}（「ファンタジー属性/冒険属性」のように）" },
  "backgrounds.drop.matching": { text: "★ 手持ち精霊と一致している属性・{属性}", label: "手持ちの精霊と同じ属性", note: "ホームのタブで、一致があるときだけ", vars: "{属性}（「ファンタジー属性/冒険属性」のように）" },
  "backgrounds.unlock.free": { text: "無料解放", label: "まだ使えない背景の解放の条件（無料）" },
  "backgrounds.unlock.readCount": { text: "本を{冊数}冊読了で解放", label: "まだ使えない背景の解放の条件（読んだ本の数）", vars: "{冊数}" },
  "backgrounds.unlock.spiritCount": { text: "精霊を{体数}体入手で解放", label: "まだ使えない背景の解放の条件（精霊の数）", vars: "{体数}" },
  "backgrounds.unlock.spiritGenre": { text: "{属性}精霊を{体数}体入手で解放", label: "まだ使えない背景の解放の条件（ある属性の精霊の数）", vars: "{属性}・{体数}" },
  "backgrounds.setting": { text: "設定中...", label: "ボタン（設定している間）", note: "場所・背景のボタンと、転送先のボタン" },
  "backgrounds.moveHere": { text: "この場所へ移る", label: "場所の本のボタン（ホームのタブ）" },
  "backgrounds.useThis": { text: "この背景を使う", label: "背景の本のボタン（ホーム以外のタブ）" },
  "backgrounds.transfer.open": { text: "↗ 他の画面にも使う", label: "他の画面にも使うボタン", note: "同じ絵が他の画面にもあるときだけ" },
  "backgrounds.transfer.heading": { text: "転送先:", label: "転送先の見出し", note: "他の画面にも使うを押したとき" },
  "backgrounds.transfer.cancel": { text: "キャンセル", label: "転送先のキャンセル" },

  // 図鑑
  "encyclopedia.back.spirit": { text: "← 獲得精霊一覧に戻る", label: "戻る（精霊の画面から来たとき）", note: "入り口が分からないときもこれ" },
  "encyclopedia.back.spiritGacha": { text: "← 精霊ガチャ画面に戻る", label: "戻る（精霊ガチャから来たとき）" },
  "encyclopedia.back.gachaSelect": { text: "← ガチャ選択に戻る", label: "戻る（ガチャ選択から来たとき）" },
  "encyclopedia.back.gacha": { text: "← 本を引く画面に戻る", label: "戻る（本を引く画面の出やすい素材から来たとき）" },
  "encyclopedia.title": { text: "図鑑", label: "見出し" },
  "encyclopedia.tab.spirits": { text: "精霊図鑑", label: "タブ（精霊）" },
  "encyclopedia.tab.materials": { text: "素材図鑑", label: "タブ（素材）" },
  "encyclopedia.emptySpirits": { text: "まだ登録された精霊がいません", label: "空のとき（精霊図鑑）" },
  "encyclopedia.emptyMaterials": { text: "まだ登録された素材がありません", label: "空のとき（素材図鑑）" },
  "encyclopedia.notOwned": { text: "未入手", label: "精霊図鑑の札の2行目（まだ持っていない精霊）", note: "持っている精霊はレベル（spirit.common.level・その種類でいちばん高いレベル）" },
  "encyclopedia.close": { text: "×", label: "詳しい窓を閉じるボタン", note: "精霊と素材の両方" },
  "encyclopedia.noDescription": { text: "説明文はまだ登録されていません", label: "説明が無いとき", note: "精霊と素材の詳しい窓の両方" },
  "encyclopedia.maxEvolutions": { text: "最大進化{回数}回", label: "精霊の詳しい窓の進化の回数", note: "進化できる精霊だけ", vars: "{回数}" },
  "encyclopedia.crossEvolve": { text: "転進化可", label: "精霊の詳しい窓の転進化の印", note: "転進化できる精霊だけ" },

  // 設定
  "settings.title": { text: "設定", label: "見出し" },
  "settings.user.heading": { text: "ユーザー", label: "ユーザーの欄の見出し" },
  "settings.user.magic": { text: "魔力:", label: "魔力の名前", note: "後ろに空白と魔力の数が付く" },
  "settings.user.points": { text: "{魔力}", label: "魔力の数", vars: "{魔力}" },
  "settings.user.breakdown": { text: "(無償: {無償} / 有償: {有償})", label: "魔力の内訳", note: "有償の魔力があるときだけ", vars: "{無償}・{有償}" },
  "settings.user.logout": { text: "ログアウト", label: "ログアウトのボタン" },
  "settings.novel.heading": { text: "小説 読書設定", label: "小説の欄の見出し" },
  "settings.direction": { text: "文字方向", label: "文字方向の名前", note: "小説と単語帳の両方" },
  "settings.vertical": { text: "縦書き ✓", label: "文字方向のボタン（縦書きのとき）", note: "小説と単語帳の両方" },
  "settings.horizontal": { text: "横書き", label: "文字方向のボタン（横書きのとき）", note: "小説と単語帳の両方" },
  "settings.fontSize": { text: "文字の大きさ", label: "文字の大きさの名前", note: "小説と単語帳の両方" },
  "settings.fontSize.small": { text: "小", label: "文字の大きさのボタン（小）", note: "小説と単語帳の両方" },
  "settings.fontSize.medium": { text: "中", label: "文字の大きさのボタン（中）", note: "小説と単語帳の両方" },
  "settings.fontSize.large": { text: "大", label: "文字の大きさのボタン（大）", note: "小説と単語帳の両方" },
  "settings.bgm.heading": { text: "BGM", label: "BGMの欄の見出し" },
  "settings.bgm.label": { text: "BGM", label: "BGMの入り切りの名前" },
  "settings.bgm.on": { text: "ON ✓", label: "BGMのボタン（鳴らしているとき）" },
  "settings.bgm.off": { text: "OFF", label: "BGMのボタン（止めているとき）" },
  "settings.bgm.volume": { text: "音量", label: "音量の名前", note: "BGMを鳴らしているときだけ" },
  "settings.vocab.heading": { text: "単語帳 読書設定", label: "単語帳の欄の見出し" },

  // ログイン
  "login.eyebrow": { text: "THE INFINITE LIBRARY", label: "題の上の小さな見出し" },
  "login.title": { text: "無限図書館", label: "題" },
  "login.intro": { text: "一頁ひらけば、まだ知らない世界。\nあなただけの物語を、ここから。", label: "題の下の文", note: "改行が効く" },
  "login.button": { text: "Google でログイン", label: "ログインのボタン" },
  "login.pending": { text: "ログインしています…", label: "ログインのボタン（ログインしている間）" },
  "login.error": { text: "ログインできませんでした。もう一度お試しください。", label: "ログインできなかったときの知らせ" },
  "login.footnote": { text: "本と出会い、精霊と歩く。\n無限に広がる図書館へようこそ。", label: "いちばん下の文", note: "改行が効く" },
} as const satisfies Record<string, UiTextDef>;
